const initialState = {
  driverRoutes: [],
  selectedRoute: "",
  pinValidity: null,
  selectedRouteName: '',
  contentLoading: false,
  reportSubmit: [],
};

const driverData = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ROUTES":
      return {
        ...state,
        driverRoutes: action.payload,
      };
    case "SELECTED_ROUTE":
      return {
        ...state,
        selectedRoute: action.payload,
      };
    case "SET_PIN_VALIDITY":
      return {
        ...state,
        pinValidity: action.payload,
      };
    case "SELECTED_ROUTE_NAME":
      return {
        ...state,
        selectedRouteName: action.payload,
      };
      case 'LOADING':
        return { ...state, contentLoading: action.payload };
        case 'SUBMIT_REPORT':
    const existingIndex = state.reportSubmit.findIndex(item => item.route_id === action.payload.route_id);
    
    if (existingIndex !== -1) {
        return {
            ...state,
            reportSubmit: state.reportSubmit.map((item, index) => {
                if (index === existingIndex) {
                    return { ...item, status: action.payload.status };
                } else {
                    return item;
                }
            })
        };
    } else {
        return {
            ...state,
            reportSubmit: [...state.reportSubmit, action.payload]
        };
    }

      case 'RESET_STATE':
        return initialState;
      
    default:
      return state;
  }
};

export default driverData;
